import { useEffect } from "react";
import useAuth from "./../hooks/useAuth";
import authInstance from "../utilities/axios/authInstance";
import refreshToken from './../utilities/axios/tokenRefresh';

const AxiosProvider = ({ children }) => {
  const { auth, setAuth } = useAuth();

  useEffect(() => {
    const requestInterceptor = authInstance.interceptors.request.use(
      config => {
        // setting this prevents a 401 on response
        config.headers['Authorization'] = "Bearer " + auth?.token;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    const responseInterceptor = authInstance.interceptors.response.use(
      async (response) => {
        return response;
      },
      async (error) => {
        if (error?.response?.status !== 401) {
          // nothing to do here, so ignore the error
          return Promise.reject(error);
        }

        const prevRequest = error.config;

        if (!prevRequest.sent) {
          prevRequest.sent = true;

          try {
            const newToken = await refreshToken(auth?.token);
            setAuth(prev => ({ ...prev, token: newToken }));
            const newConfig = { ...prevRequest, cancelToken: undefined };
            newConfig.headers['Authorization'] = 'Bearer ' + newToken;
            return authInstance(newConfig);
          } catch (error) {
            setAuth({ token: null });

            if (error.response && error.response.status === 401 && error.response.data.error === 'Token Blacklisted') {
              // handle token blacklisted error
              // log the user out or request a new token
              // logoutUser();
            }
          }

          return Promise.reject(error);
        }

        return Promise.reject(error);
      }
    );

    return () => {
      authInstance.interceptors.response.eject(responseInterceptor);
      authInstance.interceptors.request.eject(requestInterceptor);
    }
  }, [auth, setAuth]);

  return children;
}

export default AxiosProvider;